import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import HeaderBar from "./HeaderBar";
import Sidebar from "./Sidebar"; // ✅ Import the existing Sidebar

export default function AdminLayout() {
  const navigate = useNavigate();

  // ✅ Redirect to login if no token
  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (!token) navigate("/admin/login");
  }, [navigate]);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* ✅ USE EXISTING SIDEBAR */}
      <Sidebar />

      {/* ✅ MAIN CONTENT AREA */}
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* HEADER */}
        <HeaderBar />

        {/* SCROLLABLE PAGE CONTENT */}
        <main className="flex-1 overflow-y-auto p-6 bg-gray-100">
          <Outlet />
        </main>
      </div>
    </div>
  );
}